import { TextField, TextFieldProps, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import React, { useEffect, useMemo } from 'react';

type IProps = TextFieldProps & {
  title?: string;
  charLimit?: number;
};

export const WrappedTextfield: React.FC<IProps> = ({
  title,
  value,
  charLimit,
  error,
  onChange,
  helperText,
  ...rest
}: IProps) => {
  const styles = useStyles();

  const charCountHelperText = useMemo(
    () => (charLimit && typeof value === 'string' ? `${value.length}/${charLimit}` : undefined),
    [value, charLimit]
  );

  const isCharOverLimit = useMemo(() => {
    if (charLimit && typeof value === 'string') {
      return value.length >= charLimit;
    }
    return false;
  }, [value, charLimit]);

  const customHelperText = useMemo(() => {
    return `${charCountHelperText}. ${helperText ?? ''} ${isCharOverLimit ? 'Limite de caracteres atingido.' : ''}`;
  }, [charCountHelperText]);

  const isError = useMemo(() => isCharOverLimit || !!error, [isCharOverLimit, error]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!onChange) return;

    const { value } = event.target;
    if (charLimit && value.length > charLimit) {
      return;
    }

    onChange(event);
  };

  useEffect(() => console.log(isError), [isError]);

  return (
    <label>
      {title && <Typography className={styles.title}>{title}</Typography>}
      <TextField
        value={value}
        className={styles.textField}
        {...rest}
        helperText={customHelperText}
        error={isError}
        onChange={handleChange}
      />
    </label>
  );
};
